// Import Core
import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
// Import Components
import SmallCardCarousel from '../SmallCardCarousel';
// Import Utils
import getNavItemLinks from '../../../utils/getNavItemLinks';

const PopularDestinationsCardCarousel = ({section}) => {
    const data = useStaticQuery(graphql`
		query PopularDestinationsQuery {
			siteSettings: sanitySiteSettings {
        popularDestinations {
          ... on SanityRegionPage {
            _id
            _type
            title: name
            image: thumbnail {
              asset {
                gatsbyImageData(width: 205, height: 200, placeholder: BLURRED)
              }
            }
            slug {
              current
            }
            country {
              _id
              _type
              isInEurope
              slug {
                current
              }
            }
          }
          ... on SanityCountryPage {
            _id
            _type
            title: name
            image: thumbnail {
              asset {
                gatsbyImageData(width: 205, height: 200, placeholder: BLURRED)
              }
            }
            slug {
              current
            }
            isInEurope
          }
          ... on SanityCityPage {
            _id
            _type
            title: name
            image: thumbnail {
              asset {
                gatsbyImageData(width: 205, height: 200, placeholder: BLURRED)
              }
            }
            slug {
              current
            }
            country {
              _id
              _type
              isInEurope
              slug {
                current
              }
            }
          }
        }
      }
		}
	`);
    return (
      <SmallCardCarousel
        addToAnchor={section.addToAnchor}
        title={section.sectionTitle.title}
        content={section.sectionTitle.caption}
        linkText={section.navItem && section.navItem.name}
        link={(section.navItem && section.navItem.navItemUrl) && getNavItemLinks(section.navItem)}
        cardList={data.siteSettings.popularDestinations}
      />
    )
}

export default PopularDestinationsCardCarousel